import { Component, OnInit } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import { LogonPage } from '../logon/logon.page';
import { ConfigService } from '../provider/config.service';
import { AuthService } from '../services/auth.service';
import { endpoints } from '../constant/endpoints';
import { ApiService } from '../provider/api.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
    host: {
    // This is the key part!
    // It binds the 'showTabFooter' class if displayClass() returns "showTabFooter"
    // and 'hideTabFooter' class if displayClass() returns "hideTabFooter"
    '[class.showTabFooter]': 'displayClass() === "showTabFooter"',
    '[class.hideTabFooter]': 'displayClass() === "hideTabFooter"'
  }
})
export class FooterComponent  implements OnInit {
  public storeData: any = {};
  public organization: any = {};
  public customer: any;
    hasNews: boolean;
    currentUrl: string;
          private destroy$ = new Subject<void>(); // Used to unsubscribe from observables

  constructor(private configService: ConfigService,
      private navCtrl: NavController,
      private modalCtrl: ModalController,
      private authService: AuthService,
      private apiService: ApiService,
      private router: Router,          // Inject Router


  ) { }

  public ngOnInit(): void {
    this.currentUrl = this.router.url;
  this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      takeUntil(this.destroy$) // Automatically unsubscribe when the component is destroyed
    ).subscribe((event: NavigationEnd) => {
      this.currentUrl = event.urlAfterRedirects; // Use urlAfterRedirects for the final, resolved URL
      console.log('Navigated to:', this.currentUrl);
      // If displayClass is used in the template, Angular will re-evaluate it automatically.
      // If you need to trigger something else based on the URL change, do it here.
    });
    console.log('ngOnInit footer')
      this.getStoreData();
      this.checkPagePermissions();
  }
  public async getStoreData(): Promise<void> {
    this.storeData = await this.configService.getStorage('appPayload');
    this.organization = this.storeData.organization;
    console.log(this.configService);

}
  ngOnDestroy() {
    this.destroy$.next(); // Emit a value to signal unsubscription
    this.destroy$.complete(); // Complete the subject
  }
	checkPagePermissions() {

		this.apiService.get(endpoints.cms).subscribe((res) => {
			console.log(res);

			const newsItems = res.data.pages.filter(val => val.meta_title === "news" && val.is_active === true);
			this.hasNews = newsItems.length > 0;
		});
	}
navigateTo = async (page: any) => {
     this.navCtrl.navigateForward(page);
}
navigateToPage = async (page: any) => {
    this.customer = await this.authService.getAuthUser();

    if (page === '/onboarding') {
        if (
            ((this.organization.allowed_salon_booking || this.organization.allowed_product_booking)
            &&
            (this.organization.allowed_product_booking || this.organization.allowed_home_service_booking))
            
            
        ) {
            this.navCtrl.navigateBack(page);
        }
        
    } else {
        if (this.customer) {
            this.navCtrl.navigateForward(page);
        } else {
            const modal = await this.modalCtrl.create(
                {
                    'component': LogonPage,
         
                 //   'breakpoints': [0.5, 0.75]
                    'cssClass': 'my-custom-modal'
                }
            );
            modal.onDidDismiss()
                .then((data) => {
                    console.log(data);
                    if (data.data) {
                        this.customer = data.data;
                    }
                }
                );
            return modal.present();
        }
    }
}
 displayClass(): string {
    // You might want to use .startsWith() or a regex if your URLs have query parameters
    // or dynamic segments (e.g., /salon/123).
    // For exact matches, use the full path.
    const allowedPaths = [
      '/home',
      '/home-appointment',
      '/salon-appointment',
      '/onboarding',
      '/salon',
      '/product'
    ];

    // Check if the current URL (or its base path) is in the allowedPaths array
    // We use .split('?')[0] to ignore query parameters if they exist
    const currentPath = this.currentUrl.split('?')[0];

    if (allowedPaths.includes(currentPath)) {
      return 'showTabFooter';
    } else {
      return 'hideTabFooter';
    }
  }
}
